import {ITimePeriod} from '../../interfaces/HotelReservationV2/ITimePeriod';
import {IProductUseGuestCount} from '../../interfaces/HotelReservationV2/IProductUseGuestCount';
import {IProductUse} from '../../interfaces/HotelReservationV2/IProductUse';
import {Guest} from '../../model/guest/guest.model';

export class ProductUseBuilder {
    private _productUse: IProductUse;
    constructor() {
        this._productUse = <IProductUse>{};
        this._productUse.periods = []; //<ITimePeriod>
        this._productUse.guestIds = [];
        //this._productUse.guestCount = <IProductUseGuestCount>{}; todo
    }
    withQuantity (quantity: number) {
        this._productUse.quantity = quantity;
        return this;
    }
    withProductCode (productCode: string) {
        this._productUse.productCode = productCode;
        return this;
    }
    withAdults (adults: number) {
        this._productUse.adults = adults;
        return this;
    }
    withChildren (children: number) {
        this._productUse.children = children;
        return this;
    }
    withTimePeriod (timePeriod: ITimePeriod) {
        this._productUse.periods.splice(0,1, timePeriod);
        return this;
    }
    withCheckInDate (cid: string) {
        let currentCod = this._productUse.periods[0].end;
        this._productUse.periods.splice(0,1,<ITimePeriod>{start: cid, end: currentCod});
        return this;
    }
    withCheckOutDate (cod: string) {
        let currentCid = this._productUse.periods[0].start;
        this._productUse.periods.splice(0,1,<ITimePeriod>{start: currentCid, end: cod});
        return this;
    }
    withGuestId (guestId: number) {
      if (guestId) {
        this._productUse.guestIds.push(guestId)
      }
        return this
    }
    build (): IProductUse {
        return this._productUse;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/builders/product-use.builder.ts